enum PermissionType {
  Camera = 'Camera',
  Location = 'Location',
  Photo = 'Photo',
  Microphone = 'Microphone',
}

enum LoginProvider {
  Google = 'google',
  Facebook = 'facebook',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  Apple = 'apple',
  Guest = 'guest',
  UNKNOWN = 'Login provider mismatch',
}

enum Environment {
  DEVELOPMENT = 'DEVELOPMENT',
  PRODUCTION = 'PRODUCTION',
  STAGING = 'STAGING',
  UNKNOWN = 'ENVIRONMENT MISMATCH',
}

enum EnvironmentDisplay {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  PRODUCTION_SHORT = 'prod',
  STAGING = 'staging',
  UNKNOWN = 'environment mismatch',
}

enum UserLevel {
  GUEST = 'guest',
  ALLMEMBER = 'allmember',
  SEVENAPP = '7app',
  CUSTOMER = 'customer',
}

export {
  PermissionType,
  LoginProvider,
  Environment,
  UserLevel,
  EnvironmentDisplay,
}
